import { cn } from "@/lib/cn";
import { type ButtonHTMLAttributes, type ReactNode, forwardRef } from "react";

export interface ChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  children: ReactNode;
  /** Whether the chip is in active/selected state */
  active?: boolean;
  className?: string;
}

/**
 * Filter / toggle chip using the iris-chip CSS class.
 * Active state driven by data-active attribute for CSS targeting.
 */
export const Chip = forwardRef<HTMLButtonElement, ChipProps>(
  ({ children, active = false, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn("iris-chip", className)}
        data-active={active ? "true" : "false"}
        {...props}
      >
        {children}
      </button>
    );
  },
);
Chip.displayName = "Chip";
